import React, { Profiler } from "react";

import { isFrontendPerfEnabled, recordCommit } from "../utils/frontendPerf";

import type { ProfilerOnRenderCallback } from "react";

const onRender: ProfilerOnRenderCallback = (id, _phase, actualDuration) => {
	recordCommit(id, actualDuration);
};

const PerfProfiler: React.FC<PerfProfiler.Props> = ({ id, children }) => {
	if (!isFrontendPerfEnabled()) return <>{children}</>;

	return (
		<Profiler id={id} onRender={onRender}>
			{children}
		</Profiler>
	);
};

declare namespace PerfProfiler {
	interface Props {
		id: string;
		children: React.ReactNode;
	}
}

export default PerfProfiler;
